import { CRUDPathSegmentEn } from '@martech-solution/utils/constants';

const accountingPath = {
  accounting: '/erp/accounting',

  accountingAccount: '/erp/accounting/accounting-account',

  accountingPaymentRequestTicket: '/erp/accounting/payment-request-ticket',

  debtTaking: '/erp/accounting/debt-taking',
  debtPaying: '/erp/accounting/debt-paying',
  //GRPO
  grpo: '/erp/accounting/grpo',
  grpoDetail: '/erp/accounting/grpo' + CRUDPathSegmentEn.DETAIL,
  grpoDetailCode: '/erp/accounting/grpo' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  grpoAdd: '/erp/accounting/grpo' + CRUDPathSegmentEn.ADD,
  grpoEdit: '/erp/accounting/grpo' + CRUDPathSegmentEn.EDIT,

  //#region  MasterData

  // Incoterm - Điều khoản thương mại
  incoterm: '/erp/accounting/master-data/incoterm',
  incotermDetail: '/erp/accounting/master-data/incoterm' + CRUDPathSegmentEn.DETAIL,
  incotermDetailCode: '/erp/accounting/master-data/incoterm' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  incotermAdd: '/erp/accounting/master-data/incoterm' + CRUDPathSegmentEn.ADD,
  incotermEdit: '/erp/accounting/master-data/incoterm' + CRUDPathSegmentEn.EDIT,

  // Payment method - Hình thức thanh toán
  tradePaymentMethod: '/erp/accounting/master-data/trade-payment-method',
  tradePaymentMethodDetail: '/erp/accounting/master-data/trade-payment-method' + CRUDPathSegmentEn.DETAIL,
  tradePaymentMethodDetailCode: '/erp/accounting/master-data/trade-payment-method' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  tradePaymentMethodAdd: '/erp/accounting/master-data/trade-payment-method' + CRUDPathSegmentEn.ADD,
  tradePaymentMethodEdit: '/erp/accounting/master-data/trade-payment-method' + CRUDPathSegmentEn.EDIT,

  // Main Shipping method - Phương tiện vận chuyển chính
  mainShippingMethod: '/erp/accounting/master-data/main-shipping-method',
  mainShippingMethodDetail: '/erp/accounting/master-data/main-shipping-method' + CRUDPathSegmentEn.DETAIL,
  mainShippingMethodDetailCode: '/erp/accounting/master-data/main-shipping-method' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  mainShippingMethodAdd: '/erp/accounting/master-data/main-shipping-method' + CRUDPathSegmentEn.ADD,
  mainShippingMethodEdit: '/erp/accounting/master-data/main-shipping-method' + CRUDPathSegmentEn.EDIT,

  // Shipping Stage - Chặng vận chuyển
  shippingStage: '/erp/accounting/master-data/shipping-stage',
  shippingStageDetail: '/erp/accounting/master-data/shipping-stage' + CRUDPathSegmentEn.DETAIL,
  shippingStageDetailCode: '/erp/accounting/master-data/shipping-stage' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  shippingStageAdd: '/erp/accounting/master-data/shipping-stage' + CRUDPathSegmentEn.ADD,
  shippingStageEdit: '/erp/accounting/master-data/shipping-stage' + CRUDPathSegmentEn.EDIT,

  // Payment document - Chứng từ thanh toán
  paymentDocument: '/erp/accounting/master-data/payment-document',
  paymentDocumentDetail: '/erp/accounting/master-data/payment-document' + CRUDPathSegmentEn.DETAIL,
  paymentDocumentDetailCode: '/erp/accounting/master-data/payment-document' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  paymentDocumentAdd: '/erp/accounting/master-data/payment-document' + CRUDPathSegmentEn.ADD,
  paymentDocumentEdit: '/erp/accounting/master-data/payment-document' + CRUDPathSegmentEn.EDIT,
  // Payment document detail requirement - Yêu cầu chi tiết cho chứng từ
  paymentDocumentDetailRequirement: '/erp/accounting/master-data/payment-document-detail-requirement',
  paymentDocumentDetailRequirementDetail:
    '/erp/accounting/master-data/payment-document-detail-requirement' + CRUDPathSegmentEn.DETAIL,
  paymentDocumentDetailRequirementDetailCode:
    '/erp/accounting/master-data/payment-document-detail-requirement' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  paymentDocumentDetailRequirementAdd:
    '/erp/accounting/master-data/payment-document-detail-requirement' + CRUDPathSegmentEn.ADD,
  paymentDocumentDetailRequirementEdit:
    '/erp/accounting/master-data/payment-document-detail-requirement' + CRUDPathSegmentEn.EDIT,

  // International Trade Agreement  - Điều ước quốc tế, pháp luật và tập quán thương mại quốc tế
  internationalTradeAgreement: '/erp/accounting/master-data/international-trade-agreement',
  internationalTradeAgreementDetail:
    '/erp/accounting/master-data/international-trade-agreement' + CRUDPathSegmentEn.DETAIL,
  internationalTradeAgreementAdd: '/erp/accounting/master-data/international-trade-agreement' + CRUDPathSegmentEn.ADD,
  internationalTradeAgreementEdit: '/erp/accounting/master-data/international-trade-agreement' + CRUDPathSegmentEn.EDIT,

  // #region  Asset-Allocation - Bảng phân bổ tài sản chung #region  Asset-Allocation
  assetAllocation: '/erp/accounting/asset-allocation',
  assetAllocationDetail: '/erp/accounting/asset-allocation' + CRUDPathSegmentEn.DETAIL,
  assetAllocationCode: '/erp/accounting/asset-allocation' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  assetAllocationAdd: '/erp/accounting/asset-allocation' + CRUDPathSegmentEn.ADD,

  //#region  Asset-Allocation
  assetAllocationEdit: '/erp/accounting/asset-allocation' + CRUDPathSegmentEn.EDIT,
  //#endregion

  //#region TransactionMaster
  transactionMaster: '/erp/accounting/financial-accounting/transaction-master',
  transactionMasterDetail: '/erp/accounting/financial-accounting/transaction-master' + CRUDPathSegmentEn.DETAIL,
  transactionMasterAdd: '/erp/accounting/financial-accounting/transaction-master' + CRUDPathSegmentEn.ADD,
  transactionMasterEdit: '/erp/accounting/financial-accounting/transaction-master' + CRUDPathSegmentEn.EDIT,
  //#endregion TransactionMaster

  //#region DocumentLog
  documentLog: '/erp/accounting/financial-accounting/document-log',
  documentLogDetail: '/erp/accounting/financial-accounting/document-log' + CRUDPathSegmentEn.DETAIL
  //#endregion DocumentLog
};

export default accountingPath;
